import "core-js/modules/es.array.includes.js";
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toHandlers as _toHandlers, mergeProps as _mergeProps, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "u-dict-list-wrapper"
};
const _hoisted_2 = {
  class: "u-dict-list-toolbar-wrapper"
};
const _hoisted_3 = {
  class: "u-dict-cate-wrapper"
};
const _hoisted_4 = {
  class: "u-dict-cate-items-wrapper"
};
const _hoisted_5 = {
  class: "u-dict-body-wrapper"
};
const _hoisted_6 = {
  class: "u-dict-body-header"
};
const _hoisted_7 = {
  class: "u-dict-body-list-wrapper"
};
import { computed, onMounted, reactive, ref, watch } from 'vue';
import { modal, useUDictEditor } from '@/share/components';

import { fetchApi } from '/Users/ytx/ytx/projects/jxpj/web/jxpj-client/src/server/auto-import.js';
export default {
  __name: 'mg-u-dict-list',
  props: {
    cate: {
      type: String,
      default: ''
    },
    actions: {
      type: Array,
      default: () => ['add-cate', 'edit-cate', 'delete-cate', 'add-item', 'edit-item', 'delete-item']
    }
  },
  setup(__props) {
    const props = __props;
    const cateTableRef = ref();
    const itemTableRef = ref();
    const dataList = ref([]);
    const cateList = ref([]);
    const selectCateRow = ref(); // 当前选择的字典行
    const selectItemRow = ref(); // 当前选择的字典项行

    const {
      showUDictCateEditor,
      showUDictItemEditor
    } = useUDictEditor();
    const cateGridEvents = {
      'currentRowChange'({
        row
      }) {
        const {
          id
        } = row || {};
        if (!id) return;
        // 加载字典项数据
        selectCateRow.value = row;
        loadUserDictionaryList(id);
      },
      'cellDblclick'({
        row
      }) {
        handleEditCateRow(row);
      }
    };
    const cateGridOptions = reactive({
      border: true,
      headerAlign: 'center',
      columns: [{
        type: 'seq',
        title: '序号',
        width: 70,
        fixed: 'left'
      }, {
        field: 'name',
        title: '字典名称',
        width: 110
      }, {
        field: 'desc',
        title: '字典说明',
        width: 200
      }, {
        title: '操作',
        width: 120,
        slots: {
          default: 'action'
        },
        fixed: 'right'
      }],
      rowConfig: {
        isCurrent: true,
        isHover: true,
        keyField: 'id'
      },
      columnConfig: {
        resizable: true
      }
    });
    const selectCate = computed(() => {
      const {
        name = '[未选择]'
      } = selectCateRow.value || {};
      return name;
    });
    function setCurrentCateRow(row) {
      !!cateTableRef.value && cateTableRef.value.setCurrentRow(row);
    }
    function setCurrentItemRow(row) {
      !!itemTableRef.value && itemTableRef.value.setCurrentRow(row);
    }
    const itemGridOptions = reactive({
      border: true,
      headerAlign: 'center',
      columns: [{
        type: 'seq',
        title: '序号',
        width: 70,
        fixed: 'left'
      }, {
        field: 'title',
        title: '标题',
        width: 200
      }, {
        field: 'value',
        title: '值',
        width: 80
      }, {
        title: '操作',
        width: 120,
        slots: {
          default: 'action'
        },
        fixed: 'right'
      }],
      rowConfig: {
        isCurrent: true,
        isHover: true,
        keyField: 'id'
      },
      columnConfig: {
        resizable: true
      }
    });
    const itemGridEvents = {
      'currentRowChange'({
        row
      }) {
        selectItemRow.value = row;
      },
      'cellDblclick'({
        row
      }) {
        handleEditItemRow(row);
      }
    };
    const {
      loading: loadCateLoading,
      runAsync: getUserDictionaryCateListApi
    } = fetchApi('common.uDictionary.getCateList');
    const {
      loading,
      runAsync: getUserDictionaryListApi
    } = fetchApi('common.uDictionary.getList');
    const {
      runAsync: removeUserDictionaryApi
    } = fetchApi('common.uDictionary.remove');
    const {
      runAsync: removeUserDictionaryCateApi
    } = fetchApi('common.uDictionary.removeCate');
    const loadUserDictionaryCateList = async () => {
      const {
        error,
        rows
      } = await getUserDictionaryCateListApi({});
      if (error) return;
      cateList.value = rows;
      if (rows.length > 0) {
        selectCateRow.value = rows[0];
        loadUserDictionaryList(rows[0].id).catch(() => {});
      }
    };
    const loadUserDictionaryList = async cate => {
      const {
        error,
        rows
      } = await getUserDictionaryListApi({
        cate
      });
      if (error) return;
      dataList.value = rows;
    };
    const refresh = async () => {
      const {
        id: cate = ''
      } = selectCateRow.value || {};
      return loadUserDictionaryList(cate);
    };
    const handleDeleteItemRow = async row => {
      const {
        id,
        title
      } = row || {};
      if (!id) {
        modal.message.info('未选择要删除的数据项');
        return Promise.resolve(false);
      }
      const confirm = modal.confirm('删除确认', '确认要删除当前数据项吗？删除后不可恢复');
      if (!confirm) return Promise.resolve(false);
      const {
        error
      } = await removeUserDictionaryApi({
        id
      });
      if (error) {
        modal.notification.error(`删除数据项[${title}]失败:${error}`);
        return Promise.resolve(false);
      }
      modal.notification.success(`删除数据项[${title}]成功`);
      refresh().catch(() => {});
      return Promise.resolve(true);
    };
    const handleEditItemRow = async row => {
      const {
        id
      } = row || {};
      if (!id) {
        modal.message.info('未选择要修改的数据项');
        return Promise.resolve(false);
      }
      setCurrentItemRow(row);
      const res = await showUDictItemEditor('修改数据项', {
        id
      });
      if (!res) return Promise.resolve(false);
      refresh().catch(() => {});
      return Promise.resolve(res);
    };
    const handleAddItem = async () => {
      const {
        id: cate
      } = selectCateRow.value || {};
      if (!cate) {
        modal.message.error('请选择要添加数据项的数据字典');
        return Promise.resolve(false);
      }
      const res = await showUDictItemEditor('添加数据项', {
        id: '',
        cate
      });
      if (!res) return Promise.resolve(false);
      refresh().catch(() => {});
      return Promise.resolve(res);
    };
    const handleAddCate = async () => {
      const res = await showUDictCateEditor('添加数据字典', '');
      if (!res) return Promise.resolve(false);
      refreshCateList().catch(() => {});
      return Promise.resolve(res);
    };
    async function handleDeleteCateRow(row) {
      const {
        id,
        name
      } = row || {};
      if (!id) {
        modal.message.info('未选择要删除的数据字典');
        return Promise.resolve(false);
      }
      setCurrentItemRow(row);
      const {
        error
      } = await removeUserDictionaryCateApi({
        id
      });
      if (error) {
        modal.notification.error(`删除数据字典[${name}]失败:${error}`);
        return Promise.resolve(false);
      }
      refreshCateList().catch(() => {});
      return Promise.resolve(true);
    }
    const refreshCateList = async () => {
      return loadUserDictionaryCateList();
    };
    async function handleEditCateRow(row) {
      const {
        id
      } = row || {};
      if (!id) {
        modal.message.info('未选择要修改的数据字典');
        return Promise.resolve(false);
      }
      setCurrentCateRow(row);
      const res = await showUDictCateEditor('编辑数据字典', id);
      if (!res) return Promise.resolve(false);
      refreshCateList().catch(() => {});
      return Promise.resolve(res);
    }
    watch(() => props.cate, cate => {
      if (cate) {
        loadUserDictionaryList(cate);
      }
    }, {
      immediate: true
    });
    onMounted(() => {
      loadUserDictionaryCateList();
    });
    return (_ctx, _cache) => {
      const _component_vxe_button = _resolveComponent("vxe-button");
      const _component_vxe_button_group = _resolveComponent("vxe-button-group");
      const _component_vxe_layout_header = _resolveComponent("vxe-layout-header");
      const _component_vxe_grid = _resolveComponent("vxe-grid");
      const _component_vxe_split_pane = _resolveComponent("vxe-split-pane");
      const _component_vxe_split = _resolveComponent("vxe-split");
      const _component_vxe_layout_body = _resolveComponent("vxe-layout-body");
      const _component_vxe_layout_container = _resolveComponent("vxe-layout-container");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_vxe_layout_container, {
        vertical: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_vxe_layout_header, {
          fixed: ""
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_vxe_button_group, null, {
            default: _withCtx(() => [__props.actions.includes('add-cate') ? (_openBlock(), _createBlock(_component_vxe_button, {
              key: 0,
              icon: "vxe-icon-add",
              status: "primary",
              onClick: _withModifiers(handleAddCate, ["stop"])
            }, {
              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [_createTextVNode("添加字典", -1)]))]),
              _: 1
            })) : _createCommentVNode("", true), __props.actions.includes('edit-cate') ? (_openBlock(), _createBlock(_component_vxe_button, {
              key: 1,
              icon: "vxe-icon-edit",
              onClick: _cache[0] || (_cache[0] = _withModifiers(() => handleEditCateRow(selectCateRow.value), ["stop"]))
            }, {
              default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createTextVNode("编辑字典", -1)]))]),
              _: 1
            })) : _createCommentVNode("", true), __props.actions.includes('delete-cate') ? (_openBlock(), _createBlock(_component_vxe_button, {
              key: 2,
              status: "danger",
              icon: "vxe-icon-delete",
              onClick: _cache[1] || (_cache[1] = _withModifiers($event => handleDeleteCateRow(selectCateRow.value), ["stop"]))
            }, {
              default: _withCtx(() => [...(_cache[6] || (_cache[6] = [_createTextVNode("删除字典", -1)]))]),
              _: 1
            })) : _createCommentVNode("", true)]),
            _: 1
          }), _cache[10] || (_cache[10] = _createElementVNode("span", {
            style: {
              "display": "block",
              "width": "20px"
            }
          }, null, -1)), _createVNode(_component_vxe_button_group, null, {
            default: _withCtx(() => [__props.actions.includes('add-item') ? (_openBlock(), _createBlock(_component_vxe_button, {
              key: 0,
              icon: "vxe-icon-add-sub",
              onClick: _withModifiers(handleAddItem, ["stop"])
            }, {
              default: _withCtx(() => [...(_cache[7] || (_cache[7] = [_createTextVNode("添加数据项", -1)]))]),
              _: 1
            })) : _createCommentVNode("", true), __props.actions.includes('edit-item') ? (_openBlock(), _createBlock(_component_vxe_button, {
              key: 1,
              icon: "vxe-icon-edit",
              onClick: _cache[2] || (_cache[2] = _withModifiers(() => handleEditItemRow(selectItemRow.value), ["stop"]))
            }, {
              default: _withCtx(() => [...(_cache[8] || (_cache[8] = [_createTextVNode("编辑数据项", -1)]))]),
              _: 1
            })) : _createCommentVNode("", true), __props.actions.includes('delete-item') ? (_openBlock(), _createBlock(_component_vxe_button, {
              key: 2,
              status: "danger",
              icon: "vxe-icon-delete",
              onClick: _cache[3] || (_cache[3] = _withModifiers(() => handleDeleteItemRow(selectItemRow.value), ["stop"]))
            }, {
              default: _withCtx(() => [...(_cache[9] || (_cache[9] = [_createTextVNode("删除数据项", -1)]))]),
              _: 1
            })) : _createCommentVNode("", true)]),
            _: 1
          })])]),
          _: 1
        }), _createVNode(_component_vxe_layout_body, null, {
          default: _withCtx(() => [_createVNode(_component_vxe_split, {
            height: "100%",
            "action-config": {
              showPrevButton: true
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_vxe_split_pane, {
              width: "45%"
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_cache[13] || (_cache[13] = _createElementVNode("div", {
                class: "u-dict-cate-header"
              }, "数据字典列表", -1)), _createElementVNode("div", _hoisted_4, [_createVNode(_component_vxe_grid, _mergeProps({
                ref_key: "cateTableRef",
                ref: cateTableRef,
                loading: _unref(loadCateLoading),
                data: cateList.value,
                height: "100%"
              }, cateGridOptions, _toHandlers(cateGridEvents)), {
                action: _withCtx(({
                  row
                }) => [_createVNode(_component_vxe_button_group, {
                  size: "mini"
                }, {
                  default: _withCtx(() => [__props.actions.includes('edit-cate') ? (_openBlock(), _createBlock(_component_vxe_button, {
                    key: 0,
                    mode: "text",
                    icon: "vxe-icon-edit",
                    status: "primary",
                    onClick: _withModifiers(() => handleEditCateRow(row), ["stop"])
                  }, {
                    default: _withCtx(() => [...(_cache[11] || (_cache[11] = [_createTextVNode("编辑", -1)]))]),
                    _: 1
                  }, 8, ["onClick"])) : _createCommentVNode("", true), __props.actions.includes('delete-cate') ? (_openBlock(), _createBlock(_component_vxe_button, {
                    key: 1,
                    mode: "text",
                    icon: "vxe-icon-delete",
                    status: "danger",
                    onClick: _withModifiers(() => handleDeleteCateRow(row), ["stop"])
                  }, {
                    default: _withCtx(() => [...(_cache[12] || (_cache[12] = [_createTextVNode("删除", -1)]))]),
                    _: 1
                  }, 8, ["onClick"])) : _createCommentVNode("", true)]),
                  _: 2
                }, 1024)]),
                _: 1
              }, 16, ["loading", "data"])])])]),
              _: 1
            }), _createVNode(_component_vxe_split_pane, null, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, _toDisplayString(selectCate.value) + "数据字典项", 1), _createElementVNode("div", _hoisted_7, [_createVNode(_component_vxe_grid, _mergeProps({
                ref_key: "itemTableRef",
                ref: itemTableRef,
                data: dataList.value,
                loading: _unref(loading),
                height: "100%"
              }, itemGridOptions, _toHandlers(itemGridEvents)), {
                action: _withCtx(({
                  row
                }) => [_createVNode(_component_vxe_button_group, {
                  size: "mini"
                }, {
                  default: _withCtx(() => [__props.actions.includes('edit-item') ? (_openBlock(), _createBlock(_component_vxe_button, {
                    key: 0,
                    mode: "text",
                    icon: "vxe-icon-edit",
                    status: "primary",
                    onClick: _withModifiers(() => handleEditItemRow(row), ["stop"])
                  }, {
                    default: _withCtx(() => [...(_cache[14] || (_cache[14] = [_createTextVNode("编辑", -1)]))]),
                    _: 1
                  }, 8, ["onClick"])) : _createCommentVNode("", true), __props.actions.includes('delete-item') ? (_openBlock(), _createBlock(_component_vxe_button, {
                    key: 1,
                    mode: "text",
                    status: "danger",
                    icon: "vxe-icon-delete",
                    onClick: _withModifiers(() => handleDeleteItemRow(row), ["stop"])
                  }, {
                    default: _withCtx(() => [...(_cache[15] || (_cache[15] = [_createTextVNode("删除", -1)]))]),
                    _: 1
                  }, 8, ["onClick"])) : _createCommentVNode("", true)]),
                  _: 2
                }, 1024)]),
                _: 1
              }, 16, ["data", "loading"])])])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      })]);
    };
  }
};